import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackScreenView } from '../utils/analytics';

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackScreenView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);
}

export default usePageTracking;
